import { AbstractModel } from "./abstract-model";
import { Classificacao } from "./registro-produto";

export class CicloVidaLicenca extends AbstractModel {
  nome: string = '';
  liberarDias: number = 7;
  idModuloPrimeiro: number;
  nomeModuloPrimeiro: string;
  padrao: boolean = false;
  classificacao: Classificacao;
  software: string = 'HABIL_EMPRESARIAL';
  itens: CicloVidaLicencaItem[] = [];
}

export class CicloVidaLicencaItem extends AbstractModel {
  liberarDias: number = 30;
  idModuloNovo: number;
  nomeModuloNovo: string;
}